import * as tslib_1 from "tslib";
import { Type } from 'class-transformer';
import { AchievementBadgeResultDto } from './achievement-badge-result-dto';
import { CertificateResultDto } from './certificate-result-dto';
import { DegreeResultDto } from './degree-result-dto';
const ɵ0 = () => DegreeResultDto, ɵ1 = () => CertificateResultDto, ɵ2 = () => AchievementBadgeResultDto;
export class UserBiographyResultDto {
    get photoUrl() {
        return !!this.imageBase64Data && !!this.imageBase64Data.length
            ? this.imageBase64Data
            : 'assets/images/avatar_question_round.png';
    }
}
tslib_1.__decorate([
    Type(ɵ0),
    tslib_1.__metadata("design:type", Array)
], UserBiographyResultDto.prototype, "degrees", void 0);
tslib_1.__decorate([
    Type(ɵ1),
    tslib_1.__metadata("design:type", Array)
], UserBiographyResultDto.prototype, "certificates", void 0);
tslib_1.__decorate([
    Type(ɵ2),
    tslib_1.__metadata("design:type", Array)
], UserBiographyResultDto.prototype, "achievements", void 0);
export { ɵ0, ɵ1, ɵ2 };
